<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row align="center">
        <v-col>
          <h3><v-icon class="mr-2">mdi-cart-outline</v-icon> Pedidos Cartão de Crédito</h3>
        </v-col>
        <v-col class="text-right" cols="3">
          <v-text-field v-model="search" outlined dense placeholder="Pesquisar" rounded hide-details />
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn depressed color="primary" small class="text-center mr-1" dark @click="downloadCSV()" block>
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV</v-btn
          >
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>

      <v-data-table
        :items="orderReturn"
        :items-per-page="30"
        :headers="headers"
        :loading="loading"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 60, -1],
          'items-per-page-text': 'Itens por Página',
        }"
        multi-sort
      >
        <template v-slot:[`item.orderIdMarketplace`]="{ item }">
          {{ item.orderIdMarketplace }}

          <TheToolTip label="Link Hubble">
            <v-icon small class="ml-2" @click="loadContent(item.orderIdMarketplace)">
              mdi-link
            </v-icon>
          </TheToolTip>

          <TheToolTip label="Link Vtex" v-if="checkAcess(['admin', 'supplier'])">
            <v-icon small class="ml-2" @click="loadVtex(item.orderIdMarketplace)">
              mdi-shield-link-variant-outline
            </v-icon>
          </TheToolTip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-icon class="ml-2" small @mouseenter="getProducts(item)">mdi-magnify-plus-cursor</v-icon>
              </span>
            </template>
            <span>
              <ul v-if="products.length > 0">
                <li v-for="product in products" :key="product.skuId">
                  {{ product.skuId }} - {{ product.productName }} x
                  {{ product.orderProductAmount }}
                </li>
              </ul>
              <v-progress-circular indeterminate color="amber" v-if="products.length === 0"></v-progress-circular>
            </span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.clientFirstName`]="{ item }">{{ item.clientFirstName }} {{ item.clientLastName }}</template>
        <template v-slot:[`item.clientDocument`]="{ item }">
          {{ item.clientDocument | formatDocument }}
        </template>
        <template v-slot:[`item.orderStatus`]="{ item }">
          <v-layout justify-center>
            <v-chip label :color="getColor(item.orderStatus)" dark>
              {{ item.orderStatusDescription }}
            </v-chip>
          </v-layout>
        </template>

        <template v-slot:[`item.orderSellerStatus`]="{ item }">
          <v-layout justify-center>
            <v-chip label :color="getColor(item.orderSellerStatus)" dark @click="statusChange(item)">{{ getStatusSeller(item.orderSellerStatus) }}</v-chip>
          </v-layout>
        </template>

        <template v-slot:[`item.orderCreationDate`]="{ item }">
          {{ item.orderCreationDate | formatFullDate }}
        </template>

        <template v-slot:[`item.orderValue`]="{ item }">{{ item.orderValue | formatMoney }}</template>

        <template v-slot:[`item.paymentSystemName`]="{ item }">
          <img v-if="item.paymentSystemName" :src="convertToImg(item.paymentSystemName)" />
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip label="Atualizar" v-if="checkAcess(['admin', 'supplier'])">
            <v-btn dark small @click="updateSingleOrder(item.orderIdMarketplace)" depressed color="blue darken-1" class="pa-0 ma-1 rounded-md">
              <v-icon small dark>mdi-sync</v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip
            label="Erro de comunicação com o Seller"
            v-if="!item.orderIdSeller && item.orderSellerStatus > 3 && item.orderSellerStatus < 7 && item.integrationType != 'Manual' && item.integrationType != 'Customizada'"
          >
            <v-btn dark small @click="resyncOrder(item.orderIdHubble)" depressed color="yellow darken-1" class="pa-0 ma-1 rounded-md">
              <v-icon small>mdi-alert-rhombus</v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip label="Cancelar Pedido">
            <v-btn
              dark
              small
              @click="cancelOrder(item.orderIdHubble)"
              depressed
              color="red darken-1"
              class="pa-0 ma-1 rounded-md"
              v-show="checkAcess(['admin', 'supplier']) && item.orderSellerStatus < 5"
            >
              <v-icon small dark>mdi-cart-off</v-icon>
            </v-btn>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'

import { baseApiUrl, showError } from '@/global'
import { getColor, getStatusSeller } from '@/plugins/generic.js'

import TheToolTip from '@/components/TheToolTip'

export default {
  name: 'Orders',
  components: {
    TheToolTip,
  },
  computed: {
    ...mapState(['user', 'permissions', 'menu']),
    orderReturn: function() {
      const orderReturn = this.filterOrder()
      this.calculateTotals()
      this.toggleSellerFilter()
      return orderReturn
    },
    isAdmin() {
      for (let i = 0; i < this.permissions.length; i++) {
        const element = this.permissions[i]
        if (element.idRule === 'admin' || element.idRule === 'supplier-order') {
          return true
        }
      }
      return false
    },
  },
  watch: {
    sellerFilter() {
      this.toggleSellerFilter()
    },
  },
  directives: { mask },
  data: () => ({
    cancelRequestDialog: false,
    confirmDeliveryDialog: false,
    date: [],
    dataInput: false,
    orderDeliveryDate: null,
    dialog: false,
    infoRow: false,
    infoMessage: '',
    headers: [
      { value: 'orderIdMarketplace', text: 'ID Order' },
      // { value: 'sellerDescription', text: 'Seller' },
      { value: 'clientFirstName', text: 'Nome Cliente' },
      // { value: 'clientDocument', text: 'Documento', align: 'center', width: 'none' },
      { value: 'orderCreationDate', text: 'Data', align: 'center' },
      // { value: 'orderSellerStatus', text: 'Status Seller', align: 'center' },
      { value: 'orderStatus', text: 'Status Vtex', align: 'center' },
      { value: 'orderValue', text: 'Valor', align: 'center' },
      { value: 'orderNfe', text: 'NF', align: 'center' },
      { value: 'paymentSystemName', text: 'Forma', align: 'center' },
      { value: 'nsu', text: 'NSU', align: 'center' },
      // { value: 'action', text: 'Ações', align: 'center' },
    ],
    lastSync: '',
    infoData: false,
    loadingPeriod: false,
    loading: false,
    menu1: null,
    menu2: null,
    nfeDialog: false,
    on: false,
    order: {},
    orders: [],
    period: null,
    products: [],
    search: null,
    sellers: [],
    sellerFilter: [],
    sellerOrders: [],
    status: 0,
    statusFilter: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    statusFiltersButtons: [],
    totals: {
      valueMax: 0,
      valueMean: 0,
      count: 0,
      mean: 0,
      waitingPayment: 0,
      waitingInvoice: 0,
      waitingTracking: 0,
      waitingDelivery: 0,
      cancelRequest: 0,
      canceled: 0,
      invoiced: 0,
    },
    trackDialog: false,
    trackNfeObject: {
      orderNfe: '',
      orderTracking: '',
      orderTrackingUrl: '',
    },
  }),
  methods: {
    checkAcess(groups) {
      return groups.find((group) => {
        return this.user.groups.includes(group)
      })
    },
    calculateTotals() {
      this.totals.valueMax = 0
      this.totals.valueMean = 0
      this.totals.count = 0
      this.totals.mean = 0
      this.totals.canceled = 0
      this.totals.waitingPayment = 0
      this.totals.waitingTracking = 0
      this.totals.waitingInvoice = 0
      this.totals.cancelRequest = 0
      this.totals.waitingDelivery = 0
      this.totals.invoiced = 0
      this.totals.other = 0

      let quantidade = 0

      this.orders.forEach((element) => {
        if (this.statusFilter.includes(element.orderSellerStatus) && (this.sellerFilter.includes(element.sellerId) || this.sellerFilter.length == 0)) {
          this.totals.valueMax += element.orderValue
          this.totals.valueMean += element.orderValue
          quantidade++
        }
        if (this.sellerFilter.includes(element.sellerId) || this.sellerFilter.length == 0) {
          switch (element.orderSellerStatus) {
            case 1:
              this.totals.other++
              break
            case 2:
              this.totals.waitingPayment++
              break
            case 4:
              this.totals.waitingInvoice++
              break
            case 5:
              this.totals.waitingTracking++
              break
            case 6:
              this.totals.waitingDelivery++
              break
            case 7:
              this.totals.invoiced++
              break
            case 8:
              this.totals.cancelRequest++
              break
            case 9:
              this.totals.canceled++
              break
            default:
              break
          }
        }
      })

      this.totals.valueMean /= quantidade
      this.totals.count = quantidade
      this.totals.mean = quantidade
      this.loadStatusFiltersButtons()
    },
    cancelOrder(orderIdHubble) {
      if (confirm(`Deseja Cancelar ${orderIdHubble}?`)) {
        this.cancelRequestDialog = false
        this.trackDialog = false
        this.dialog = false
        let url = `${baseApiUrl}/order/${orderIdHubble}/cancel`
        axios
          .get(url)
          .then((res) => {
            this.order = {}
            this.calculateTotals()
            this.loadOrders()
          })
          .catch(showError)
      }
    },
    confirmDelivery(orderIdHubble) {
      const orderDeliveryDate = this.orderDeliveryDate
      if (!orderDeliveryDate) {
        alert('Você precisa preencher uma data de entrega')
        return false
      }
      let url = `${baseApiUrl}/order/${orderIdHubble}/confirmDelivery`
      axios
        .post(url, { orderDeliveryDate })
        .then((res) => {
          this.order = {}
          this.confirmDeliveryDialog = false
          this.calculateTotals()
          this.loadOrders()
        })
        .catch(showError)
    },
    convertToImg(img) {
      const images = require.context('../../assets/payment/', false, /\.png$/)
      return images('./' + img + '.png')
    },
    denyCancelOrder(orderIdHubble) {
      this.cancelRequestDialog = false
      let url = `${baseApiUrl}/order/${orderIdHubble}/cancel`
      axios
        .post(url)
        .then((res) => {
          this.order = {}
          this.trackNfeObject = {}
          this.calculateTotals()
          this.loadOrders()
        })
        .catch(showError)
    },
    filterActive(filter) {
      return this.statusFilter.includes(filter)
    },
    filterOrder() {
      let orderTemp = []
      let orderReturn = []
      this.orders.map((element) => {
        this.statusFilter.forEach((fil) => {
          if (fil == element.orderSellerStatus) {
            orderTemp.push(element)
          }
        })
      })
      if (this.sellerFilter.length > 0) {
        orderTemp.map((element) => {
          this.sellerFilter.forEach((fil) => {
            if (fil == element.sellerId) {
              orderReturn.push(element)
            }
          })
        })
      } else {
        orderReturn = orderTemp
      }
      return orderReturn
    },
    formatStringData(data) {
      let dia = data.split('/')[0]
      let mes = data.split('/')[1]
      let ano = data.split('/')[2]
      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2) + 'T12:00:00-03:00'
    },
    getColor,
    getStatusSeller,
    getProducts(item) {
      this.products = []
      const url = `${baseApiUrl}/order/${item.orderIdHubble}/products`
      axios
        .get(url)
        .then((res) => {
          this.products = res.data
        })
        .catch(showError)
    },
    loadContent(order) {
      let route = this.$router.resolve({
        name: 'Order',
        params: { id: order },
      })
      window.open(route.href, '_blank')
    },
    loadVtex(order) {
      window.open(` https://lojawap.myvtex.com/admin/checkout/#/orders/${order}`, '_blank')
    },
    loadOrders() {
      if (this.trackDialog === false && this.dialog === false) {
        this.loading = true

        const url = `${baseApiUrl}/order-credit-card`
        axios
          .get(url)
          .then((res) => {
            localStorage.setItem('period', JSON.stringify(null))
            localStorage.setItem('date', JSON.stringify([]))
            this.date = []
            this.orders = res.data
            this.infoData = false
            this.loading = false
            this.calculateTotals()
          })
          .catch(showError)
      }
    },
    loadStatusFiltersButtons() {
      this.statusFiltersButtons = [
        {
          title: this.totals.waitingPayment,
          icon: 'mdi-clock-in',
          status: 2,
        },
        {
          title: this.totals.waitingInvoice,
          icon: 'mdi-clock-fast',
          status: 4,
        },

        {
          title: this.totals.waitingTracking,
          icon: 'mdi-truck-check',
          status: 5,
        },
        {
          title: this.totals.waitingDelivery,
          icon: 'mdi-truck-fast',
          status: 6,
        },
        {
          title: this.totals.invoiced,
          icon: 'mdi-cash',
          status: 7,
        },
        {
          title: this.totals.cancelRequest,
          icon: 'mdi-cart-off',
          status: 8,
        },
        {
          title: this.totals.canceled,
          icon: 'mdi-cart-off',
          status: 9,
        },
        {
          title: this.totals.other,
          icon: 'mdi-clock-alert-outline',
          status: 1,
        },
      ]
    },
    loadSellers() {
      const url = `${baseApiUrl}/seller`
      axios
        .get(url)
        .then((res) => {
          this.sellers = res.data
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    openTrackDialog() {
      this.trackDialog = true
    },
    resyncOrder(orderIdHubble) {
      if (confirm('Deseja ressincronizar o pedido no Seller?')) {
        let url = `${baseApiUrl}/order/${orderIdHubble}/resync`
        axios
          .post(url)
          .then((res) => {
            this.order = {}
            this.trackNfeObject = {}
            this.trackDialog = false
            this.calculateTotals()
            this.loadOrders()
          })
          .catch(showError)
          .finally(() => {
            this.order = {}
            this.trackNfeObject = {}
            this.trackDialog = false
            this.calculateTotals()
            this.loadOrders()
          })
      }
    },
    statusChange(item) {
      this.order = item
      switch (this.order.orderSellerStatus) {
        case 1:
          break
        case 2:
          break
        case 3:
          break
        case 4:
          this.trackDialog = true
          break
        case 5:
          this.trackDialog = true
          break
        case 6:
          this.confirmDeliveryDialog = true
          break
        case 7:
          break
        case 8:
          this.cancelRequestDialog = true
          break
        default:
          break
      }
    },
    sendTrackNfe(order) {
      let orderIdHubble = order.orderIdHubble
      let url = ''
      if (this.order.orderSellerStatus === 4) {
        if (!this.trackNfeObject.orderNfe || !this.trackNfeObject.date) {
          alert('É preciso preencher o número da nota e a data')
          return false
        }
        url = `${baseApiUrl}/order/nfe/${orderIdHubble}`
      } else {
        if (!this.trackNfeObject.orderTracking || !this.trackNfeObject.orderTrackingUrl || !this.trackNfeObject.orderCarrier || !this.trackNfeObject.date) {
          alert('É preciso preencher todos os campos do tracking')
          return false
        }
        url = `${baseApiUrl}/order/tracking/${orderIdHubble}`
      }

      this.trackNfeObject.orderSendDate = this.trackNfeObject.date

      let orderAuthorizedDate = new Date(this.order.orderAuthorizedDate)
      let orderSendDate = new Date(this.formatStringData(this.trackNfeObject.date))
      orderAuthorizedDate.setHours(0, 0, 0, 0)
      orderSendDate.setHours(0, 0, 0, 0)

      if (this.order.orderSellerStatus !== 4) {
        if (orderSendDate < orderAuthorizedDate) {
          alert('Data de postagem não pode ser uma data menor que a data de aprovação')
          return false
        }
      }

      axios
        .post(url, this.trackNfeObject)
        .then((res) => {
          order = res.data
          this.order = {}
          this.trackNfeObject = {}
          this.calculateTotals()
          this.loadOrders()
        })
        .catch(showError)
        .finally((this.trackDialog = false))
    },
    toggleFilter(filter) {
      if (this.statusFilter.includes(filter)) {
        let index = this.statusFilter.indexOf(filter)
        this.statusFilter.splice(index, 1)
      } else {
        this.statusFilter.push(filter)
      }
      this.calculateTotals()
      localStorage.setItem('statusFilter', JSON.stringify(this.statusFilter))
    },
    toggleSellerFilter() {
      this.calculateTotals()
      localStorage.setItem('sellerFilter', JSON.stringify(this.sellerFilter))
    },
    updateSingleOrder(orderIdMarketplace) {
      if (confirm('Deseja Atualizar a order?')) {
        let url = `${baseApiUrl}/vtex/updateSingleOrder`
        let object = { orderIdMarketplace: orderIdMarketplace }
        axios
          .post(url, object)
          .then((res) => {
            this.order = {}
            this.trackNfeObject = {}
            this.trackDialog = false
            this.calculateTotals()
            this.loadOrders()
          })
          .catch(showError)
          .finally(() => {
            this.order = {}
            this.trackNfeObject = {}
            this.trackDialog = false
            this.calculateTotals()
            this.loadOrders()
          })
      }
    },
    viewOrder(event) {
      this.order = event
      this.dialog = !this.dialog
    },
    downloadCSV() {
      const data = this.orders
      const fileName = 'download-boleto-pix'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.loadOrders()
    this.loadSellers()
    this.loadStatusFiltersButtons()
  },
  created() {
    if (localStorage.getItem('statusFilter')) this.statusFilter = JSON.parse(localStorage.getItem('statusFilter'))
    if (localStorage.getItem('date')) this.date = JSON.parse(localStorage.getItem('date'))
    if (localStorage.getItem('period')) this.period = JSON.parse(localStorage.getItem('period'))
    if (localStorage.getItem('sellerFilter')) this.sellerFilter = JSON.parse(localStorage.getItem('sellerFilter'))
  },
}
</script>

<style scoped>
.header-dash {
  padding-bottom: 10px;
  border-bottom: 2px solid #efefef !important;
}

.v-application .headline {
  font-size: 2rem !important;
}
.order-detailed {
  padding: 10px;
}

.order-highlight {
  text-align: right;
  background: #f0932b !important;
  color: #ffffff !important;
  font-size: 2em !important;
  line-height: 80%;
}

.order-highlight b {
  font-size: 0.7em !important;
  line-height: 110%;
  color: #1f1f1f;
}
</style>
